{
  "slug": "iq-percentiles",
  "title": "Tabla de Percentiles de CI y Explicación",
  "description": "Traducir las puntuaciones comunes en rangos de percentil aproximados.",
  "category": "Estadísticas de CI",
  "sections": [
    {
      "heading": "Significado",
      "paragraphs": [
        "Traducir las puntuaciones comunes en rangos de percentil aproximados.",
        "La interpretación depende de la población, el instrumento, la edición, el año, el muestreo, el idioma y el método."
      ]
    },
    {
      "heading": "Lea las tablas cuidadosamente",
      "paragraphs": [
        "Compruebe la representatividad, la incertidumbre, las exclusiones y si los valores se midieron o se estimaron.",
        "Los promedios de grupo tienen una superposición sustancial y no pueden determinar a un individuo."
      ]
    },
    {
      "heading": "Una conclusión responsable",
      "paragraphs": [
        "Prefiera conjuntos de datos primarios e intervalos transparentes. Evite las afirmaciones causales de la correlación por sí sola.",
        "Para un individuo, utilice las normas de edad apropiadas y la documentación técnica."
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "OCDE — Datos y metodología de PISA",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "Traduzca las puntuaciones comunes en rangos de percentil aproximados. Contenido revisado 18 Julio 2026."
}
